import { render, staticRenderFns } from "./StffList.vue?vue&type=template&id=631cfba4&scoped=true&"
import script from "./StffList.vue?vue&type=script&lang=js&"
export * from "./StffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cfba4",
  null
  
)

export default component.exports